// extracted by mini-css-extract-plugin
export var audioPlayer = "_s5-0";